import React from 'react';
import {Alert} from "antd";

export default ({title, info}) => {
  
  return (
    <div className={'title-info'}>
      <h2 className={'title'}>{title}</h2>
      <Alert className={'mb-10 text-center info'} message={info} type="info"/>
    </div>
  
  );
  
}